import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faBoxOpen, faSearch } from "@fortawesome/free-solid-svg-icons";
import { IUserInfo } from "../../services/interfaces/userInfo";

interface IMobileBottomNavProps {
  userInfo: IUserInfo | null | undefined;
}

function MobileBottomNav(props: IMobileBottomNavProps) {
  const { userInfo } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const iconClass = (path: string) =>
    isActive(path)
      ? "flex flex-col items-center text-orangeCustom scale-125 transition-transform duration-400 ease-in-out"
      : "flex flex-col items-center text-yellowCustom hover:text-orangeCustom";

  function redirectByUserRole(role: "TRAVELER" | "RESIDENT" | null) {
    if (role === "TRAVELER") {
      navigate('/trade_requests');
    } else if (role === "RESIDENT") {
      navigate('/trade_propositions');
    } else {
      alert('role inconnu');
    }
  }

  return (
    <nav className="fixed bottom-0 pb-4 pt-2 px-2 bg-white/90 backdrop-blur-md backdrop-saturate-150 w-full rounded-t-md left-0 right-0 border-gray-200 md:hidden z-50">
      <div className="flex justify-around py-2 text-xs bg-greenCustom rounded-full">
        <button
          type="button"
          onClick={() => redirectByUserRole(userInfo?.role ?? null)}
          className={userInfo?.role === "TRAVELER" ? iconClass('/trade_requests') : iconClass('/trade_propositions')}
        >
          <FontAwesomeIcon icon={faList} size="lg" />
          <span>{userInfo?.role === "TRAVELER" ? "Demandes" : "Propositions"}</span>
        </button>

        <button onClick={() => navigate('/my_trocs')} className={iconClass('/my_trocs')}
          type="button"
        >
          <FontAwesomeIcon icon={faBoxOpen} size="lg" />
          <span>Éléments</span>
        </button>

        <button onClick={() => navigate('/search_trocs')} className={iconClass('/search_trocs')}
          type="button"
        >
          <FontAwesomeIcon icon={faSearch} size="lg" />
          <span>Recherche</span>
        </button>
      </div>
    </nav>
  );
}

export default MobileBottomNav;